import { memo } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { PreloaderBlock, PreLoaderContainer } from "components/styles/styles";

const Preloader = ({ overlay, sx }) => {
  return (
    <PreLoaderContainer sx={sx} className={`${overlay ? "overlay" : ""}`}>
      <PreloaderBlock>
        <CircularProgress />
      </PreloaderBlock>
    </PreLoaderContainer>
  );
};

export default memo(Preloader);
